// extracted by mini-css-extract-plugin
module.exports = {"b1ajsnxj":"b1ajsnxj","bxjuzgd":"bxjuzgd"};